import { Label as Icon } from "@mui/icons-material";
import { Typography } from "@mui/material";
import type { FC } from "react";
import { CostStatusColors } from "../data/BaseEntity";
import type { CostStatus } from "./costApi";
import { costStatusToName } from "./costsUtils";

interface Props {
  value: CostStatus;
}

const CostStatusView: FC<Props> = ({ value }) => (
  <Typography>
    <Icon
      style={{
        paddingRight: 5,
        verticalAlign: "bottom",
        color: CostStatusColors[value],
      }}
    />
    {costStatusToName(value)}
  </Typography>
);

export default CostStatusView;
